import axios from 'axios';
import { adminApi } from './api';

/* ==========================================
  1. Midibus Integration (Third-party)
========================================= */

const midibusApi = axios.create({
  baseURL: import.meta.env.VITE_MIDIBUS_API_KEY, // .env 확인 필요
});

/** 미디버스 토큰 조회 (자체 서버, 로그인 사용자 Authorization 필요) */
export const fetchMidibusToken = async () => {
  return await adminApi.get('/api/admin/video/token');
};

/**
 * 미디버스 동영상 카테고리 조회
 * 
 * @param {string} token - 미디버스 인증 토큰
 * @returns {Promise} 카테고리 목록 응답
 */
export const fetchMidibusCategories = async (token) => {
  return await midibusApi.get('/v2/media', {
    headers: { 'X-Mbus-Token': token },
  });
};

/** 미디버스 동영상 상세 정보 조회 */
export const fetchMidibusMediaDetail = async ({ token, categoryId, mediaId }) => {
  return await midibusApi.get(`/v2/media/${categoryId}/${mediaId}`, {
    headers: { 'X-Mbus-Token': token },
  });
};

/** 미디버스 채널 생성 */
export const createMidibusChannel = async ({ token, name }) => {
  return await midibusApi.post('/v2/channel',
    { channel_name: name, open: true },
    { headers: { 'X-Mbus-Token': token } }
  );
};

/** 미디버스 채널 조회 */
export const fetchMidibusChannel = async (token) => {
  return await midibusApi.get(`/v2/channel/`, {
    headers: { 'X-Mbus-Token': token },
  });
};

/** 미디버스 카테고리 생성 */
export const createMidibusCategory = async ({ token, name, channelId }) => {
  return await midibusApi.post('/v2/media',
    { category_name: name, save_origin: true, channel_id_list: [channelId] },
    { headers: { 'X-Mbus-Token': token } }
  );
};

/** 미디버스 동영상 업로드 */
export const uploadMidibusMedia = async ({ token, categoryId, formData }) => {
  return await midibusApi.post(`/v2/media/${categoryId}`, formData, {
    headers: {
      'X-Mbus-Token': token,
      'Content-Type': 'multipart/form-data',
    },
  });
};

/** 미디버스 동영상 삭제 */
export const deleteMidibusMedia = async ({ token, categoryId, mediaId }) => {
  return await midibusApi.delete(`/v2/media/${categoryId}/${mediaId}`, {
    headers: { 'X-Mbus-Token': token },
  });
};

/** 미디버스 카테고리 삭제 */
export const deleteMidibusCategory = async ({ token, categoryId }) => {
  return await midibusApi.delete(`/v2/media/${categoryId}`, {
    headers: { 'X-Mbus-Token': token },
  });
};


/* ==========================================
  2. Admin Backend API
========================================== */

/**
 * 동영상 강의 목록 조회
 * @param {Object} params - { courseId }
 */
export const fetchVideoList = async (params) => {
  const { courseId } = params;
  const response = await adminApi.get(`/api/admin/videos/course/${courseId}`);
  // 응답 구조: ApiResponse<List<VideoResponse>>
  return response.data?.data || response.data || response;
};

/**
 * 과정에 동영상 추가 (단일 영상 추가)
 * @param {Object} videoData - { courseId, courseCategory, videoSeq, videoName, mediaId, videoIntro?, videoObject?, attachedLink? }
 */
export const createVideo = async (videoData) => {
  const response = await adminApi.post(`/api/admin/videos`, videoData);
  return response;
};

/** 동영상 강의 수정 (DB) */
export const updateVideo = async (videoData) => {
  // 백엔드: PUT /api/admin/videos (@RequestBody VideoUpdateRequest)
  const response = await adminApi.put(`/api/admin/videos`, videoData);
  return response;
};

/** 동영상 강의 삭제 (DB) */
export const deleteVideo = async (videoId) => {
  const response = await adminApi.delete(`/api/admin/videos/${videoId}`);
  return response;
};